import React from "react";
import {  Container, Grid} from "@mui/material";
import styled from "@emotion/styled";
import {
  AbsoluiteImage,
  Div,
  GridWraper,
} from "../../../../Styles/style";
import herobg from "../../../../../assets/Images/herobg.png";
import heroImage from "../../../../../assets/Images/heroImage.png";
import SectionsHeading from "../../SectionsHeading";
import Paragraph from "../../Paragraph";
import CustomButton from "../../CustomBtn";
const OuterContinerWraper = styled(Container)`
  width: 100%;
  min-height: calc(100vh - 73px) !important;
  padding: 0 !important;
  background: ${(props) => props.theme.pageColor};
`;
const ContinerWraper = styled(Container)`
  width: 100%;
  min-height: calc(100vh - 90px);
  border-radius: 20px;
  background-image: url(${herobg});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;





const HeroSection = () => {
  return (
    <OuterContinerWraper maxWidth="xxl" id="home">
      <ContinerWraper>
        <GridWraper container>
          <Grid item xs={12}>
            <SectionsHeading fs1399="90px" p="40px 0">NEVER SELL YOUR SHIA</SectionsHeading>
          </Grid>
            <AbsoluiteImage style={{zIndex:"999"}} mw1399="450px" src={heroImage}/>
          <Grid container item xs={12} sx={{p:"20px 0"}}>
            <Div>
              <Paragraph fm="RobotoM">
              Access your SHIA's value today, without losing out on tomorrow's gains!
              </Paragraph>
            </Div>
            <Div>
              <CustomButton href="/dashboard" hbgc="#53616f8a" hc="#fff">
              Launch App
              </CustomButton>
              <CustomButton c="#fff" bgc="#53616f8a" hbgc="#fff" hc="#000">
              Explore
              </CustomButton>
            </Div>
          </Grid>
          
        </GridWraper>
      </ContinerWraper>
    </OuterContinerWraper>
  );
};

export default HeroSection;
